<template>
  <a-card type="inner" size="small" :bordered="false">
    <a-skeleton :loading="! ready">
      <a-form-model :labelCol="labelCol" :wrapperCol="wrapperCol" :model="item" :rules="rules" ref="sponsorForm">
        <a-divider dashed orientation="left"> Sponsor Information</a-divider>

        <a-form-model-item label="Sponsor Name" prop="sponsor_name" v-model="item.sponsor_name">
          <a-input v-model="item.sponsor_name" placeholder="Sponsor Name">
            <a-icon slot="prefix" type="safety-certificate" />
          </a-input>
        </a-form-model-item>

        <a-form-model-item :wrapperCol="{ span: this.wrapperCol.span, offset: this.labelCol.span }">
          <a-button :loading="loading.submit" type="primary" @click="submit" icon="save">Save</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-skeleton>
  </a-card>
</template>

<script>
export default {
  props: {
    sponsor: {
      required: true
    },
    baseRoute: {
      type: String,
      default: 'hyperion.finances.sponsor'
    }
  },
  computed: {
    ready() {
      return ! this.loading.dataset && ! this.loading.item
    },
    creating() {
      return this.sponsor === null
    },
    updateUrl() {
      return this.routeUri(this.baseRoute + '.update', { sponsor_hash: this.sponsor.hash })
    },
    createUrl() {
      return this.routeUri(this.baseRoute + '.store')
    }
  },
  data: () => ({
    labelCol: { span: 8 },
    wrapperCol: { span: 10 },
    loading: {
      dataset: false,
      item: false,
      submit: false
    },
    rules: {
      sponsor_name: [
        { required: true, message: "Sponsor is required", trigger: 'blur' },
      ]
    },
    item: {
      sponsor_name: ''
    },
    dataset: {
      sponsors: []
    }
  }),
  created() {
    if (this.sponsor instanceof Object)
      this.item = this.sponsor

    if (this.sponsor instanceof String)
      this.getItem()
  },
  methods: {
    getItem() {
      this.loading.item = true
      this.$http.get(this.updateUrl)
        .then((r) =>this.item = r.data)
        .catch((e) => this.handleXhrError(e))
        .finally(() => this.loading.item = false)
    },
    reload() {
      this.$emit('success')
      this.$notification.success({
        message: "Success",
        description: "Data has been successfully saved!",
        onClose: () => window.location.reload()
      });
    },
    update() {
      this.$http.put(this.updateUrl, this.item)
        .then(() => this.reload())
        .then((e) => this.handleXhrError(e))
    },
    create() {
      this.$http.post(this.createUrl, this.item)
        .then(() => this.reload())
        .catch((e) => this.handleXhrError(e))
    },
    submit() {
      this.$refs.sponsorForm.validate(valid => {
        if (valid) {
          this.loading.submit = true
          this.creating ? this.create() : this.update()
        } else {
          return false
        }
      })
    }
  }
}
</script>
